var _g, _rect, _polygon;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMusicNoteMute = function SvgMusicNoteMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.7 15",
    style: {
      enableBackground: "new 0 0 13.7 15"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_2",
    transform: "translate(-336.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(319.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(17.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#3C96F0",
    d: "M12.2,0.1L5.7,2C4.9,2.2,4.3,3,4.3,3.8v6.7v0.1c0,0-0.5-0.3-1.5-0.2C1.2,10.8,0,11.9,0,13.2 s1.2,2,2.8,1.8c1.5-0.2,2.7-1.4,2.7-2.6V6.5c0-0.5,0.7-0.8,0.7-0.8l5.7-1.8c0,0,0.6-0.2,0.6,0.4V9l0,0c0,0-0.6-0.3-1.6-0.2 C9.3,9,8.1,10.1,8.1,11.4c0,1.2,1.2,2,2.8,1.8c1.5-0.2,2.8-1.3,2.8-2.6V1.1C13.6,0.3,13-0.2,12.2,0.1"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: -0.4,
    transform: "matrix(0.7386 -0.6741 0.6741 0.7386 -3.5192 7.2788)",
    fill: "#3C96F0",
    width: 2,
    height: 17.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#12263A",
    points: "13.5,14.3 1.8,1.7 2.6,1 14.3,13.6 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMusicNoteMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/music_note-mute.f2eb74d5.svg";
export { ForwardRef as ReactComponent };